import React from 'react';

import {
  QuestionComponent,
  QuestionComponentProps
} from '../shared/QuestionComponent/QuestionComponent.react';

import TextHighlightInputArea from './TextHighlightInputArea.react';
import TextHighlightExplanation from './TextHighlightExplanation.react';

import './text-highlight-question.scss';

const TextHighlightQuestionComponent = ({
  actions,
  activeQuestion,
  activeQuestionSet,
  activeQuestionStore,
  activeSubject,
  customHeader,
  displayOrientation = 'default',
  guess,
  hasQuestionSetAccessPredicate,
  headingActions,
  interactive,
  isMobile,
  modifyTitle,
  navigateBackProps,
  navigateNextProps,
  postSubmissionScrollPointRef,
  showDifficulty,
  questionState
}: QuestionComponentProps) => {
  return (
    <QuestionComponent
      actions={actions}
      activeQuestion={activeQuestion}
      activeQuestionSet={activeQuestionSet}
      activeQuestionStore={activeQuestionStore}
      activeSubject={activeSubject}
      customExplanation={
        <TextHighlightExplanation
          question={activeQuestion}
          storeName={activeQuestionStore.getName()}
        />
      }
      customHeader={customHeader}
      displayOrientation={displayOrientation}
      guess={guess}
      hasQuestionSetAccessPredicate={hasQuestionSetAccessPredicate}
      headingActions={headingActions}
      interactive={interactive}
      isMobile={isMobile}
      modifyTitle={modifyTitle}
      navigateBackProps={navigateBackProps}
      navigateNextProps={navigateNextProps}
      postSubmissionScrollPointRef={postSubmissionScrollPointRef}
      questionState={questionState}
      showDifficulty={showDifficulty}
      ActiveQuestionInputArea={TextHighlightInputArea}
    />
  );
};

type TextHighlightQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const TextHighlightQuestion = {
  PreGuess: (props: TextHighlightQuestionTypeProps) => (
    <TextHighlightQuestionComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: TextHighlightQuestionTypeProps) => (
    <TextHighlightQuestionComponent {...props} questionState='PostGuess' />
  )
};

export {TextHighlightQuestion};
